import * as React from 'react';

import EmailAddress16 from './EmailAddress16';

export const emailAddress16 = () => <EmailAddress16 />;

export default {
    title: 'Icon/Line/EmailAddress16',
    component: EmailAddress16,
    parameters: {
        notes: "`import EmailAddress16 from 'box-ui-elements/es/icon/line/EmailAddress16';`",
    },
};
